var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarsNoseThroat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.625,15.698c0,0-2.532-0.152-4.295,2.822 c0.078,0.032,0.159,0.064,0.242,0.096l0.171,4.145c-0.016,0.15-0.065,0.892,0.485,1.465c0.516,0.537,1.376,0.745,2.556,0.618 l0.013-0.002c0.008-0.001,0.826-0.125,1.292,0.286c0.234,0.207,0.345,0.529,0.331,0.957l0.074,3.026h3.852l-0.161-9.336 C15.184,19.774,14.882,15.846,10.625,15.698z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M24.223,6.488 c-0.054-0.067-1.358-1.659-3.636-2.675c-2.108-0.94-5.47-1.529-9.519,1.004c-0.145,0.096-3.557,2.404-3.911,6.448l-0.002,0.021 l0.002,0.021c0.003,0.031,0.059,0.706,0.164,1.147l-2.713,3.512c-0.046,0.057-0.324,0.434-0.185,0.957 c0.101,0.381,0.394,0.734,0.872,1.057l0.083-0.367c0,0,0.659-5.23,5.384-5.279c0,0,2.197-0.246,4.807,1.277 c2.609,1.522,4.779-1.768,4.779-1.768s1.775-2.514,2.991,0.029c0,0,0.942,1.644-1.837,2.917c-2.075,0.951-3.186,1.154-3.488,4.444 v9.877h4.61c-0.142-0.971-0.569-6.176,2.023-10.231c0.106-0.14,1.201-1.623,1.717-3.844C26.855,12.919,26.883,9.718,24.223,6.488z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.502,14.79 c2.779-1.273,1.837-2.917,1.837-2.917c-1.215-2.543-2.991-0.029-2.991-0.029s-2.17,3.29-4.779,1.768s-4.807-1.277-4.807-1.277 c-4.724,0.049-5.384,5.279-5.384,5.279l-0.083,0.367c0.281,0.19,0.625,0.37,1.034,0.539c1.763-2.973,4.295-2.822,4.295-2.822 c4.257,0.147,4.56,4.076,4.56,4.076l0.161,9.336h2.668v-9.877C18.316,15.944,19.427,15.741,21.502,14.79z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarsNoseThroat);
export default __webpack_public_path__ + "static/media/ears_nose_throat.5f0ab12f0239d2f7c3f559bbb068ff15.svg";
export { ForwardRef as ReactComponent };